import { MOBILE } from '@app/constants';

import { DEFAULT_MAX_VISIBLE_COLUMN_COUNT } from '@pages/Calendar/data';

const MIN_CALENDAR_COLUMN_WIDTH = 130;

interface GetVisibleCalendarColumnsParams {
  availableGridWidth: number;
  preferredMaxColumns: number;
  isMobile: boolean;
}

export const getVisibleCalendarColumns = ({
  availableGridWidth,
  preferredMaxColumns,
  isMobile,
}: GetVisibleCalendarColumnsParams): number => {
  if (isMobile) {
    return 1;
  }

  const visibleByWidth = Math.floor(
    availableGridWidth / MIN_CALENDAR_COLUMN_WIDTH
  );

  return Math.min(preferredMaxColumns, Math.max(1, visibleByWidth));
};

export const getVisibleColumns = (
  width: number,
  preferredMaxColumns = DEFAULT_MAX_VISIBLE_COLUMN_COUNT
): number => {
  return getVisibleCalendarColumns({
    availableGridWidth: width,
    preferredMaxColumns,
    isMobile: width <= MOBILE,
  });
};
